import GenericModalCard from './generic-modal-card'

export default GenericModalCard
